export default {
  clean: () => import("/vercel/path0/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)
}